var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state-icons-wrap"},_vm._l((_vm.icons),function(icon){return _c('n-icon',_vm._b({key:icon.mod},'n-icon',icon,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }